import BaseClass from "../BaseClass.js";

export default class AutoloadContainer extends BaseClass {

    static config = {
        loadMarkerminHeight: '100px',
    }
    config = AutoloadContainer.config;

    utils = {};

    constructor(element) {
        super(element);

        this.contentUrl = this.$element.attr('data-url');
        this.pagination = false;
        this.paginationClass = null;
        this.currentPage = 0;
        this.nextPage = 0;
        this.name = this.$element.attr('data-name');
        // ladeverhalten
        this.nextLoadMarker = null;
        this.nextLoadTrigger = null;
        this.firstLoadTrigger = null;
        this.customLoad = false;
        this.customLoadListener = null;
        this.contentReloadListener = null;
        this.scrollListener = null;
        this.contentScrolledListener = null;
        this.contentResizedListener = null;
        this.firstLoadTriggerListener = null;
        this.onLoadEvent = null;
        this.continuousLoading = false;

        this.loading = false;
        this.postData = null;
        this.jqxhr = null;
        this.customViewPort = false;
        this.containerWidth = 0;
        this.windowWidth = 0;
        this.minWindowWidth = 0;


        this.init();

    }

    init() {

        if (this.$element.attr('data-custom-viewport') == "true") {
            this.customViewPort = true;
        }

        if (this.$element.attr("data-min-windowwidth") != undefined) {
            this.minWindowWidth = parseInt(this.$element.attr("data-min-windowwidth"));
        }

        const load = this.$element.data("custom-load");
        if (load) {
            this.customLoad = true;
        }

        const onLoadEvent = this.$element.data("onload-event");
        if (onLoadEvent != undefined) {
            this.onLoadEvent = onLoadEvent;
        }

        const pagination = this.$element.data("pagination");
        if (pagination) {
            this.pagination = true;
        }
        const continuousLoading = this.$element.data("continuous-loading");
        if (continuousLoading) {
            this.continuousLoading = true;
        }

        const paginationClass = this.$element.data("pagination-class");
        if (paginationClass != undefined) {
            this.paginationClass = paginationClass;
        }

        const currentPage = this.$element.attr('data-currentpage');
        if (currentPage != undefined) {
            this.currentPage = currentPage;
        }

        const nextPage = this.$element.attr('data-nextpage');
        if (nextPage != undefined) {
            this.nextPage = nextPage;
        }

        let additionalData = this.$element.attr('data-additional');
        if (additionalData != undefined && additionalData.length > 0) {
            this.setadditionalData(additionalData);
        }
        this.setWidthData();

        this.createListener();

        if (this.firstLoadTrigger.length < 1 && !this.customLoad) {
            this.loadContent();
        }
    }

    createListener() {
        let $document = $(document);
        let mySelf = this;

        if (this.customLoad) {
            // Alle weitere Listener sind nicht nötig
            this.customLoadListener = function (event, data) {
                if (mySelf.elementID == data.id) {
                    mySelf.$element.empty();
                    mySelf.loadContent(false, true, true);
                }
            };
            mySelf.$element.on('custom:load', this.customLoadListener);

        }

        this.contentReloadListener = function (event, data) {
            // kann noch opitmiert werden, loadingspinner verschwindet durch das empty
            if (mySelf.elementID == data.id) {
                mySelf.$element.empty();
                if (data.url != undefined) {
                    mySelf.contentUrl = data.url;
                }

                if (data.postData != undefined) {
                    mySelf.setFilterData(mySelf.contentUrl, data.postData, false);
                } else {
                    mySelf.loadContent(false, false, true);
                }
            }
        };


        this.scrollListener = function () {
            // Sorgt dafür, dass auch Scrolling innerhalb des Elements richtig verarbeitet wird
            $(window).trigger('scroll');
        };


        this.createContentScrolledListener();

        this.contentResizedListener = function () {
            mySelf.setWidthData();
            mySelf.trackWindowScroll();
        };

        this.$element.on('scroll', this.scrollListener);

        $document.on("content:resized", this.contentResizedListener);
        $(document).on('content:reload', this.contentReloadListener);


        this.firstLoadTrigger = this.$element.find('[data-type="loadFirstTrigger"]');
        if (this.firstLoadTrigger.length > 0) {
            this.firstLoadTriggerListener = function () {
                mySelf.loadContent();
            };
            this.firstLoadTrigger.on('click', this.firstLoadTriggerListener);
        }

    }

    createContentScrolledListener() {
        let $document = $(document);
        let mySelf = this;

        if (this.contentScrolledListener == null) {
            this.contentScrolledListener = function () {
                mySelf.trackWindowScroll();
            };
            $document.on('content:scrolled', this.contentScrolledListener);
        }
    }


    destroyListener() {
        // todo prüfen

        let $document = $(document);

        if (this.scrollListener != null) {
            this.$element.off('scroll', this.scrollListener);
        }
        if (this.contentScrolledListener != null) {
            $document.off('content:scrolled', this.contentScrolledListener);
        }
        if (this.contentResizedListener != null) {
            $document.off("content:resized", this.contentResizedListener);
        }
        if (this.contentReloadListener != null) {
            $document.off('content:reload', this.contentReloadListener);
        }

        if (this.customLoadListener != null) {
            this.$element.off('custom:load', this.customLoadListener);
        }

    }

    setWidthData() {
        this.containerWidth = this.$element.innerWidth();
        this.windowWidth = $(window).innerWidth();
    }

    removeFilterValue(filterUrl, filterParam) {
        this.contentUrl = filterUrl;

        if (this.postData != null) {

            let mySelf = this;

            let postDataParams = new URLSearchParams(mySelf.postData);
            let postDataObject = Object.fromEntries(postDataParams.entries());

            let newPostdata = '';

            Object.keys(postDataObject).forEach(key => {
                if (filterParam != key) {
                    newPostdata = newPostdata + '&' + key + '=' + postDataObject[key];
                }
            });

            this.postData = newPostdata;
        }

        this.currentPage = 0;
        this.nextPage = 0;

        this.removeData();
        this.loadContent(true);
    }

    setFilterData(filterUrl, filterData, useFilterDataOnly = false) {

        this.contentUrl = filterUrl;

        if (this.postData != null && useFilterDataOnly === false) {

            let mySelf = this;

            let filterDataParams = new URLSearchParams(filterData);
            let filterDataObject = Object.fromEntries(filterDataParams.entries());

            let postDataParams = new URLSearchParams(mySelf.postData);
            let postDataObject = Object.fromEntries(postDataParams.entries());
            let newPostDataObj = Object.assign(postDataObject, filterDataObject);

            let newPostdata = '';

            Object.keys(newPostDataObj).forEach(key => {
                newPostdata = newPostdata + '&' + key + '=' + newPostDataObj[key];
            });

            this.postData = newPostdata;
        } else {
            this.postData = filterData;
        }

        // notwendig, wenn Container schon bis zum Ende gescrollt war
        this.createContentScrolledListener();

        this.currentPage = 0;
        this.nextPage = 0;

        this.removeData();
        this.loadContent(true);
    }

    setadditionalData(additionalData) {
        this.postData = additionalData;
    }

    trackWindowScroll() {

        if (this.nextLoadMarker === null) {
            return;
        }

        if (this.customViewPort) {
            if (this.isVisible(this.$element, $(this.nextLoadMarker), 10, 1, 0)) {
                this.loadContent();
            }
        } else {
            if (this.isVisible($(window), $(this.nextLoadMarker), 10, 1, 0)) {
                this.loadContent();
            }
        }
    }

    showLoadMarker() {
        let $elements = this.$element.find('[data-type="autoloadNext"],[data-type="triggerloadNext"]');
        $elements.children('.hidden').removeClass('hidden');
    }

    removeLoadMarker($pageSection = null) {
        if ($pageSection != null) {
            $pageSection.children('[data-type="autoloadFirst"]').addClass('hidden');
            $pageSection.children('[data-type="autoloadNext"],[data-type="triggerloadNext"]').remove();
        } else {
            this.$element.children('[data-type="autoloadFirst"]').addClass('hidden');
            this.$element.children('[data-type="autoloadNext"],[data-type="triggerloadNext"]').remove();
        }

        this.nextLoadMarker = null;
        this.nextLoadTrigger = null;
    }

    initLoadViewListener($pageSection = null) {
        let $nextLoadMarker;
        if ($pageSection != null) {
            $nextLoadMarker = $pageSection.children('[data-type="autoloadNext"]');
        } else {
            $nextLoadMarker = this.$element.children('[data-type="autoloadNext"]');
        }

        if ($nextLoadMarker.length === 1) {
            this.nextLoadMarker = $nextLoadMarker;
            this.currentPage = this.nextLoadMarker.attr('data-currentpage');
            this.nextPage = this.nextLoadMarker.attr('data-nextpage');
            this.nextLoadMarker.css('minHeight', this.config.loadMarkerminHeight);
        } else {

            if (this.scrollListener != null) {
                this.$element.off('scroll', this.scrollListener);
            }
            if (this.contentScrolledListener != null) {
                $(document).off('content:scrolled', this.contentScrolledListener);
                this.contentScrolledListener = null;
            }
        }
    }

    initLoadTriggerListener() {

        // todo @stanislaw änderung prüfen
        let $nextLoadTrigger = this.$element.find('[data-type=triggerloadNext]');

        if ($nextLoadTrigger.length === 1) {
            this.nextLoadTrigger = $nextLoadTrigger;
            this.currentPage = this.nextLoadTrigger.attr('data-currentpage');
            this.nextPage = this.nextLoadTrigger.attr('data-nextpage');
            this.nextLoadTrigger.css('minHeight', this.config.loadMarkerminHeight);

            let mySelf = this;

            $nextLoadTrigger.on('click', function () {
                mySelf.loadContent();
            });
        }
    }

    appendData(data, page, contentUrl, requestData, failed = false) {

        if (failed) {
            this.$element.append(data);
            return;
        }
        if (this.pagination) {
            let $pageSection = $('<section/>');
            $pageSection.attr('data-page', page);
            $pageSection.attr('data-state', 'init');
            $pageSection.attr('data-type', 'page_section');
            $pageSection.attr('data-content-url', contentUrl);
            $pageSection.attr('data-requestdata', requestData);

            if (this.paginationClass != null) {
                $pageSection.attr('class', this.paginationClass);
            }

            this.$element.append($pageSection);
            $pageSection.append(data);

            if (page == 0) {
                this.removeLoadMarker();
            } else {
                let prevPage = page - 1;
                let $prevSection = this.$element.children('[data-page="' + prevPage + '"]');
                if ($prevSection.length != 0) {
                    this.removeLoadMarker($prevSection);
                }
            }
            this.initLoadViewListener($pageSection);
            this.initLoadTriggerListener($pageSection);

        } else {
            this.removeLoadMarker();
            this.$element.append(data);
            this.$element.trigger('autoload:container:loaded');
            $(document).trigger('content:loaded', {elementID: this.$element.attr('id')});
            if (this.onLoadEvent != null) {
                $(document).trigger(this.onLoadEvent, {elementID: this.$element.attr('id')});
            }
            this.initLoadViewListener();
            this.initLoadTriggerListener();
            if (this.continuousLoading) {
                let timeout = 10;
                let mySelf = this;
                setTimeout(function () {
                    mySelf.loadContent();
                }, timeout);
            }
        }

        this.$element.trigger('autoload:container:loaded');
        $(document).trigger('content:loaded', {elementID: this.elementID});
        if (this.onLoadEvent != null) {
            $(document).trigger(this.onLoadEvent, {elementID: this.elementID});
        }


    }

    removeData() {
        this.$element.children(':not([data-type="autoloadFirst"])').remove();
        this.$element.children('[data-type="autoloadFirst"]').removeClass('hidden');
    }


    loadContent(abortPrevious = false, ownLoadingSpinner = true, reload = false) {
        const mySelf = this;

        if (abortPrevious) {
            if (this.jqxhr !== null) {
                this.jqxhr.abort();
                this.jqxhr = null;
            }
            this.loading = false;
        }


        if (this.loading) {
            return false;
        }
        if (this.nextPage > 0 && this.currentPage === this.nextPage) {
            return false;
        }
        if (this.minWindowWidth > this.windowWidth) {
            return false;
        }

        if (ownLoadingSpinner) {
            this.showLoadMarker();
        } else {
            $(document).trigger('show:loading');
        }

        this.loading = true;
        let requestUrl = this.contentUrl;

        if (this.nextPage > 0 && !reload) {
            requestUrl += '/' + this.nextPage;
        }

        let requestData = this.postData;
        requestData += '&containerWidth=' + this.containerWidth;
        requestData += '&windowWidth=' + this.windowWidth;
        if (this.elementID != null) {
            requestData += '&containerID=' + this.elementID;
        }

        this.jqxhr = $.post(requestUrl, requestData, function () {

        }, 'html')
            .done(function (data) {
                mySelf.appendData(data, mySelf.nextPage, requestUrl, requestData);
                mySelf.loading = false;
                mySelf.jqxhr = null;
            })
            .fail(function (data) {
                mySelf.removeLoadMarker();
                mySelf.appendData(data.responseText, 0, requestUrl, requestData, true);
                mySelf.loading = false;
                mySelf.jqxhr = null;
            })
            .always(function () {
                if (ownLoadingSpinner) {
                    if (mySelf.firstLoadTrigger.length > 0) {
                        mySelf.firstLoadTrigger.remove();
                    }
                } else {
                    $(document).trigger('hide:loading');
                }
            });
    }

    setContentUrl(url) {
        this.$element.attr('data-url', url);
        this.contentUrl = url;
    }

}

